
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 337.984 337.984"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M281.899 74.186L209.495 1.781a6.083 6.083 0 00-4.3-1.781H96.588C73.272 0 54.304 18.968 54.304 42.284V295.7c0 23.316 18.968 42.284 42.284 42.284h72.405a6.083 6.083 0 000-12.164H96.588c-16.609 0-30.121-13.512-30.121-30.121V42.284c0-16.609 13.512-30.121 30.121-30.121h106.088l68.841 68.842v142.291a6.083 6.083 0 0012.164 0V78.486a6.083 6.083 0 00-1.782-4.3z"}}),_c('path',{attrs:{"d":"M277.599 72.405h-36.202c-16.608 0-30.12-13.512-30.12-30.121V6.082a6.082 6.082 0 10-12.164 0v36.202c0 23.315 18.968 42.284 42.283 42.284h36.202a6.083 6.083 0 00.001-12.163zM168.992 36.202H96.588a6.082 6.082 0 100 12.164h72.405a6.083 6.083 0 00-.001-12.164zM258.337 285.938a6.081 6.081 0 00-8.601.061l-25.341 25.703a6.083 6.083 0 008.662 8.54l25.341-25.703a6.082 6.082 0 00-.061-8.601z"}}),_c('path',{attrs:{"d":"M258.368 285.969l-25.341-25.342a6.082 6.082 0 00-8.601 8.601l25.341 25.342a6.063 6.063 0 004.3 1.781 6.082 6.082 0 004.301-10.382zM241.396 108.607H96.588a6.082 6.082 0 100 12.164h144.809a6.082 6.082 0 00-.001-12.164zM241.396 144.809H96.588a6.082 6.082 0 100 12.164h144.809a6.082 6.082 0 00-.001-12.164zM241.396 181.011H96.588a6.082 6.082 0 100 12.164h144.809a6.082 6.082 0 00-.001-12.164z"}})])
          )
        }
      }
    